<!-- Hero Start -->
<section class="bg-half-170 d-table agency-wrapper w-100" id="home">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-7 col-md-7">
        <div class="title-heading mt-4">
          <h6 class="text-primary mb-2">Pedro Luis Pérez Collado</h6>
          <h1 class="display-4 font-weight-bold mb-3">
            Physician by heart.<br />Engineer by choice.
          </h1>
          <p class="para-desc text-muted">
            MD from UNAM, trained at Mexico's National Cancer Institute. Currently a SWE intern on the FDE team at Microsoft, finishing my Computer Science degree at Tecnológico de Monterrey.
          </p>
          <div class="mt-4 pt-2">
            <a href="https://www.linkedin.com/in/perez-collado/" target="_blank" class="btn btn-primary mt-2 mr-2">
              <i class="uil uil-linkedin mr-1"></i> LinkedIn
            </a>
            <a href="https://github.com/plpcollado" target="_blank" class="btn btn-outline-primary mt-2 mr-2">
              <i class="uil uil-github mr-1"></i> GitHub
            </a>
            <a href="mailto:pedro@perezcollado.com" class="btn btn-outline-secondary mt-2">
              <i class="uil uil-envelope mr-1"></i> Contact
            </a>
          </div>
        </div>
      </div>
      <!--end col-->

      <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0 text-center">
        <img
          src="assets/images/pedro-hero.jpg"
          class="img-fluid rounded-circle shadow-lg"
          style="max-width: 320px; object-fit: cover; height: 320px;"
          alt="Pedro Luis Pérez Collado"
        />
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<div class="position-relative">
  <div class="shape overflow-hidden text-light">
    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
        fill="currentColor"
      ></path>
    </svg>
  </div>
</div>
<!-- Hero End -->

<!-- About Start -->
<section class="section bg-light" id="about">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-5 text-center mb-4 mb-lg-0 order-1 order-lg-0">
        <img
          src="assets/images/pedro-about.jpg"
          class="img-fluid rounded-md shadow-lg"
          style="max-width: 380px;"
          alt="Pedro Luis Pérez Collado"
        />
      </div>
      <!--end col-->

      <div class="col-lg-7 order-0 order-lg-1">
        <div class="section-title ml-lg-4">
          <h6 class="text-primary">My Story</h6>
          <h4 class="title mb-4">From the clinic to the codebase</h4>
          <p class="text-muted">
            I studied medicine at UNAM. From my second year, I was already collaborating with research teams at the National Cancer Institute, which is where I got close to the data side of healthcare and started seeing problems that medicine alone couldn't solve.
          </p>
          <p class="text-muted">
            That pulled me toward software. I joined Tecnológico de Monterrey for Computer Science and, at the same time, became one of the first engineers at Presalud, a healthtech startup where we built a prescription platform now used by 5% of psychiatrists in Mexico. Today I'm finishing my CS degree while working as a SWE intern on Microsoft's FDE team, remote from Mexico City.
          </p>
          <div class="row mt-4">
            <div class="col-6 text-center mb-3">
              <h3 class="font-weight-bold text-primary mb-1">MD</h3>
              <p class="text-muted mb-0 small">UNAM · National Cancer Institute</p>
            </div>
            <div class="col-6 text-center mb-3">
              <h3 class="font-weight-bold text-primary mb-1">5%</h3>
              <p class="text-muted mb-0 small">of psychiatrists in Mexico on a platform I built</p>
            </div>
            <div class="col-6 text-center">
              <h3 class="font-weight-bold text-primary mb-1">2M+</h3>
              <p class="text-muted mb-0 small">crime records analyzed with ML</p>
            </div>
            <div class="col-6 text-center">
              <h3 class="font-weight-bold text-primary mb-1">MSFT</h3>
              <p class="text-muted mb-0 small">SWE Intern · FDE Team</p>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!-- About End -->

<!-- Experience Start -->
<section class="section" id="experience">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h6 class="text-primary">Where I've been</h6>
          <h4 class="title mb-4">Experience</h4>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row">
      <div class="col-md-4 mt-4 pt-2">
        <div class="card border-0 shadow rounded-md text-center p-4 h-100">
          <div class="h2 text-primary mb-3">
            <i class="uil uil-hospital"></i>
          </div>
          <h5 class="font-weight-bold">National Cancer Institute</h5>
          <h6 class="text-primary mb-3">Physician · Researcher</h6>
          <p class="text-muted mb-0">
            While studying medicine at UNAM, I started collaborating with research teams at Mexico's National Cancer Institute from my second year of medical school. Worked across clinical data, oncology research, and the intersection of medicine and information.
          </p>
        </div>
      </div>
      <!--end col-->

      <div class="col-md-4 mt-4 pt-2">
        <div class="card border-0 shadow rounded-md text-center p-4 h-100">
          <div class="h2 text-primary mb-3">
            <i class="uil uil-rocket"></i>
          </div>
          <h5 class="font-weight-bold">Presalud</h5>
          <h6 class="text-primary mb-3">Founding Engineer</h6>
          <p class="text-muted mb-0">
            Joined as one of the first engineers while studying CS at Tec. Built PresaludRX from scratch, a digital prescription platform now used by 5% of psychiatrists in Mexico. Owned the full stack, from architecture and integrations to shipping features.
          </p>
        </div>
      </div>
      <!--end col-->

      <div class="col-md-4 mt-4 pt-2">
        <div class="card border-0 shadow rounded-md text-center p-4 h-100">
          <div class="h2 text-primary mb-3">
            <i class="uil uil-window-grid"></i>
          </div>
          <h5 class="font-weight-bold">Microsoft</h5>
          <h6 class="text-primary mb-3">SWE Intern · FDE Team · Redmond</h6>
          <p class="text-muted mb-0">
            Currently in my last semester at Tec, interning on Microsoft's FDE (Finance Data &amp; Experiences) team in Redmond. Building tools for enterprise-scale financial partner operations, remote from Mexico City.
          </p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!-- Experience End -->

<!-- Projects Start -->
<section class="section bg-light" id="projects">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h6 class="text-primary">What I've built</h6>
          <h4 class="title mb-4">Projects</h4>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row">
      <!-- MedSpace -->
      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card border-0 shadow rounded-md h-100">
          <div class="card-body p-4">
            <div class="text-primary h3 mb-3">
              <i class="uil uil-clinic-medical"></i>
            </div>
            <h5 class="font-weight-bold">MedSpace</h5>
            <h6 class="text-muted mb-3">Healthcare Clinic Rental Marketplace</h6>
            <p class="text-muted">
              Marketplace connecting medical professionals with clinic landlords. React 19 / Next.js 15 frontend with geospatial search via MapLibre GL, Quarkus/Java 21 backend on Google Cloud Run, Stripe payments, Firebase Auth, and Terraform-provisioned infrastructure with full CI/CD.
            </p>
            <div class="mt-3">
              <span class="badge badge-soft-primary mr-1 mb-1">React 19</span>
              <span class="badge badge-soft-primary mr-1 mb-1">Next.js 15</span>
              <span class="badge badge-soft-primary mr-1 mb-1">Java / Quarkus</span>
              <span class="badge badge-soft-primary mr-1 mb-1">GCP</span>
              <span class="badge badge-soft-primary mb-1">Stripe</span>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <!-- CDMX Crime Dashboard -->
      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card border-0 shadow rounded-md h-100">
          <div class="card-body p-4">
            <div class="text-primary h3 mb-3">
              <i class="uil uil-chart-line"></i>
            </div>
            <h5 class="font-weight-bold">CDMX Crime Predictive Dashboard</h5>
            <h6 class="text-muted mb-3">Urban AI · Spatial Intelligence</h6>
            <p class="text-muted">
              Geospatial dashboard for forecasting crime hotspots across Mexico City. Engineered features from 2M+ incident records, built K-Means clustering and XGBoost classification (82% ROC-AUC), and integrated Prophet time-series forecasting (0.48 MAE) for 24-48h predictions, visualized with Folium.
            </p>
            <div class="mt-3">
              <span class="badge badge-soft-primary mr-1 mb-1">Python</span>
              <span class="badge badge-soft-primary mr-1 mb-1">XGBoost</span>
              <span class="badge badge-soft-primary mr-1 mb-1">Prophet</span>
              <span class="badge badge-soft-primary mr-1 mb-1">GeoPandas</span>
              <span class="badge badge-soft-primary mb-1">Streamlit</span>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->

      <!-- PresaludRX -->
      <div class="col-lg-4 col-md-6 mt-4 pt-2">
        <div class="card border-0 shadow rounded-md h-100">
          <div class="card-body p-4">
            <div class="text-primary h3 mb-3">
              <i class="uil uil-capsule"></i>
            </div>
            <h5 class="font-weight-bold">PresaludRX</h5>
            <h6 class="text-muted mb-3">Digital Prescription Platform</h6>
            <p class="text-muted">
              Digital prescription platform used by 5% of psychiatrists in Mexico. Built on Bubble.io with Stripe, Auth0 SSO, Postmark, WhatsApp API, and Lambda backends. Took it from zero: Figma prototypes, full implementation, and CI/CD for Lambda functions.
            </p>
            <div class="mt-3">
              <span class="badge badge-soft-primary mr-1 mb-1">Bubble.io</span>
              <span class="badge badge-soft-primary mr-1 mb-1">Stripe</span>
              <span class="badge badge-soft-primary mr-1 mb-1">Auth0</span>
              <span class="badge badge-soft-primary mr-1 mb-1">AWS Lambda</span>
              <span class="badge badge-soft-primary mb-1">Figma</span>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!-- Projects End -->

<!-- Contact Start -->
<section class="section" id="contact">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <h6 class="text-primary">Let's connect</h6>
          <h4 class="title mb-4">Get in touch</h4>
          <p class="text-muted para-desc mb-0 mx-auto">
            Whether you're building something at the intersection of healthcare and technology, looking to collaborate, or just want to say hello — reach out.
          </p>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->

    <div class="row justify-content-center mt-4">
      <div class="col-lg-4 col-md-6 text-center mt-4">
        <a href="https://www.linkedin.com/in/perez-collado/" target="_blank"
          class="btn btn-primary btn-lg btn-block">
          <i class="uil uil-linkedin mr-2"></i> Connect on LinkedIn
        </a>
      </div>
      <div class="col-lg-4 col-md-6 text-center mt-4">
        <a href="https://github.com/plpcollado" target="_blank"
          class="btn btn-outline-primary btn-lg btn-block">
          <i class="uil uil-github mr-2"></i> View GitHub
        </a>
      </div>
      <div class="col-lg-4 col-md-6 text-center mt-4">
        <a href="mailto:pedro@perezcollado.com"
          class="btn btn-outline-secondary btn-lg btn-block">
          <i class="uil uil-envelope mr-2"></i> pedro&#64;perezcollado.com
        </a>
      </div>
    </div>
    <!--end row-->
  </div>
  <!--end container-->
</section>
<!-- Contact End -->

<!-- Back to top -->
<a
  href="javascript: void(0);"
  class="btn btn-icon btn-soft-primary back-to-top"
  id="back-to-top"
  scrollToTop
>
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
